<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="page_xi"></a><strong>CONTENTS</strong></h2>
<p class="toc-chap"><a class="nounder" href="#/xhtml/ch01">A PRIMITIVE HEART</a></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch02" title="Link target outside of Sample">EARLY MADONNA</span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch03" title="Link target outside of Sample">SOME LOOSE CHANGE</span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch04" title="Link target outside of Sample">VERANDA</span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch05" title="Link target outside of Sample">HOLY MEN</span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch06" title="Link target outside of Sample">LEVELING OUT</span><a id="page_xii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?5e9ebafd